export const handleRotate = (rotation) => {
  let controls = document.querySelector('a-camera').components['look-controls'];
  controls.pitchObject.rotation.x = 0;
  controls.yawObject.rotation.y = rotation || 0;
};
